import { gql } from "@apollo/client";

export const SDUI_THEME_CREATE_MUTATION = gql`
  mutation SduiThemeCreate($input: SDUIThemeInput!) {
    sduiThemeCreate(input: $input) {
      theme {
        id
        name
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_THEME_UPDATE_MUTATION = gql`
  mutation SduiThemeUpdate($id: ID!, $input: SDUIThemeInput!) {
    sduiThemeUpdate(id: $id, input: $input) {
      theme {
        id
        name
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_THEME_DELETE_MUTATION = gql`
  mutation SduiThemeDelete($id: ID!) {
    sduiThemeDelete(id: $id) {
      theme {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_SECTION_CREATE_MUTATION = gql`
  mutation SduiSectionCreate($input: SDUISectionInput!) {
    sduiSectionCreate(input: $input) {
      section {
        id
        sectionKey
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_SECTION_UPDATE_MUTATION = gql`
  mutation SduiSectionUpdate($id: ID!, $input: SDUISectionInput!) {
    sduiSectionUpdate(id: $id, input: $input) {
      section {
        id
        sectionKey
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_SECTION_DELETE_MUTATION = gql`
  mutation SduiSectionDelete($id: ID!) {
    sduiSectionDelete(id: $id) {
      section {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_SECTION_REORDER_MUTATION = gql`
  mutation SduiSectionReorder($ids: [ID!]!) {
    sduiSectionReorder(ids: $ids) {
      sections {
        id
        sortOrder
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_CONFIG_CREATE_MUTATION = gql`
  mutation SduiConfigCreate($input: SDUIConfigInput!) {
    sduiConfigCreate(input: $input) {
      config {
        id
        key
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_CONFIG_UPDATE_MUTATION = gql`
  mutation SduiConfigUpdate($id: ID!, $input: SDUIConfigInput!) {
    sduiConfigUpdate(id: $id, input: $input) {
      config {
        id
        key
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const SDUI_CONFIG_DELETE_MUTATION = gql`
  mutation SduiConfigDelete($id: ID!) {
    sduiConfigDelete(id: $id) {
      config {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;
